// Formato valuta italiano: separatore migliaia ".", decimali "," con 2 cifre fisse.
export const parseEuro = (v) => {
  if (typeof v === "number") return v;
  const n = parseFloat(String(v ?? "").replace(/\./g, "").replace(",", "."));
  return Number.isFinite(n) ? n : 0;
};

export const formatEuroIt = (v) => {
  const s = String(v ?? "").trim();
  if (s === "") return "";
  const n = parseEuro(v);
  const [i, d] = Math.abs(n).toFixed(2).split(".");
  return `${n < 0 ? "-" : ""}${i.replace(/\B(?=(\d{3})+(?!\d))/g, ".")},${d}`;
};
